module.exports = "/_next/static/images/MaintenanceRestoration-a8c413b3093a97ca40ec36e016b2b244.webp";